export default "﻿<div>\n    <h2>Multi Room Scheduler1</h2>\n    <div data-dojo-attach-point=\"schedulerNode\"></div>\n</div>"